import React from "react";
import provisionalModuleDataBasedOnLanguage from "../../modules/lodging/searchList/provisionalModuleDataBasedOnLanguage";

export default function RoomSummarySelection ({ persons, nights, numberOfRooms, currentRoom, step, totalSteps, language }){
  const moduleData = provisionalModuleDataBasedOnLanguage(language)
  const firstRow = moduleData.roomSummaryFirstRow.replace('{step}', step).replace('{totalSteps}', totalSteps).replace('{currentRoom}', currentRoom);
  const secondRow = moduleData.roomSummarySecondRow.replace('{persons}', persons).replace('{nights}', nights);
  return <div className="flex flex-col rounded-2xl bg-[color:var(--primaryColor)] text-white p-4 text-sm">
    <span className="text-xl font-bold">{firstRow}</span>
    <span>{secondRow}</span>
  </div>
}